module.exports = __webpack_public_path__ + "img/pixel.7c7b8b49.png";